module.exports = __webpack_public_path__ + "static/conversation-ef242090a64a50d0bd49c4cee9261624.svg";